import React from 'react';
import I18n from 'i18n-js';

import { categoryForSlug } from './category_data';
import CategoryItem from './category_item';

import Tiles from '@reverbdotcom/commons/src/components/tiles';
import OverflowingRow from '@reverbdotcom/commons/src/components/overflowing_row';

interface IProps {
  noTitle?: boolean;
}

const categoryList = [
  'electric-guitars',
  'keyboards-and-synths',
  'acoustic-guitars',
  'amps',
  'effects-and-pedals',
  'drums-and-percussion',
  'bass-guitars',
  'pro-audio',
  'dj-and-lighting-gear',
  'folk-instruments',
  'band-and-orchestra',
  'software',
  'home-audio',
  'parts',
  'accessories',
].map(categoryForSlug);

export default function HomepageCategories(props: IProps) {
  const title = props.noTitle ? null : I18n.t('discovery.homepage.categories.heading');

  return (
    <section>
      <OverflowingRow
        title={title}
      >
        <Tiles
          loading={false}
          expectedCount={categoryList.length}
          singleRow
          largeTiles
        >
          {categoryList.map((category, i) => {
            return (
              <CategoryItem
                categoryItem={category}
                position={i}
                key={i}
              />
            );
          })}
        </Tiles>
      </OverflowingRow>
    </section>
  );
}
